export function getJsonSchemaDate(date: Date): string {
  return date.toISOString().replace(/^([0-9-]+).*/, "$1");
}
